'use client';

import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { FC, useRef } from 'react';
import { BlogTagDto } from '@/components/BlogPage/types';
import Radio, { RadioItemButton } from '@/components/shared/Fields/radio';
import HorizontalFadeScroller from '@/components/shared/HorizontalFadeScroller';
import css from './style.module.scss';
interface Props {
  tags: BlogTagDto[];
  selectedTags: string[];
  onTagsChange: (tags: string[]) => void;
}
const TagsFilter: FC<Props> = t0 => {
  const $ = _c(16);
  const {
    tags,
    selectedTags,
    onTagsChange
  } = t0;
  let t1;
  if ($[0] !== tags) {
    t1 = tags.map(_temp);
    $[0] = tags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tagsOptions = t1;
  const clearRef = useRef(null);
  const showClearAll = selectedTags.length > 0;
  let t2;
  let t3;
  if ($[2] !== showClearAll) {
    t2 = () => {
      const el = clearRef.current;
      if (!el) {
        return;
      }
      if (showClearAll) {
        gsap.to(el, {
          width: "82px",
          marginRight: 12,
          opacity: 1,
          scale: 1.05,
          duration: 0.28,
          ease: "back.out(1.7)",
          onComplete: () => {
            gsap.to(el, {
              scale: 1,
              duration: 0.12
            });
          }
        });
      } else {
        gsap.to(el, {
          width: 0,
          marginRight: 0,
          opacity: 0,
          scale: 0.92,
          duration: 0.22,
          ease: "power2.in"
        });
      }
    };
    t3 = {
      dependencies: [showClearAll]
    };
    $[2] = showClearAll;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useGSAP(t2, t3);
  let t4;
  if ($[5] !== onTagsChange) {
    t4 = <div ref={clearRef} className={css.clearAllWrapper}><RadioItemButton isActive={false} label="Clear all" onClick={() => onTagsChange([])} /></div>;
    $[5] = onTagsChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onTagsChange) {
    t5 = value => onTagsChange(value as string[]);
    $[7] = onTagsChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== selectedTags || $[10] !== t5 || $[11] !== tagsOptions) {
    t6 = <Radio multiple={true} className={css.radio} selectedValue={selectedTags} options={tagsOptions} typographyVariant="body-s" onChange={t5} />;
    $[9] = selectedTags;
    $[10] = t5;
    $[11] = tagsOptions;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <HorizontalFadeScroller><div className={css.tagsFilter}>{t4}{t6}</div></HorizontalFadeScroller>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default TagsFilter;
function _temp(tag) {
  return {
    id: tag.id,
    value: tag.name,
    label: tag.name
  };
}